import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import MenuPage from './pages/Menu/MenuPage';
import OrderStatusPage from './pages/Order/OrderStatusPage';

const globalStyles = `
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { background: #0d0d12; -webkit-font-smoothing: antialiased; }
  ::-webkit-scrollbar { width: 4px; }
  ::-webkit-scrollbar-track { background: #121218; }
  ::-webkit-scrollbar-thumb { background: #2a2a3a; border-radius: 2px; }
  @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.4} }
  @keyframes spin { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }
`;

export default function App() {
  return (
    <BrowserRouter>
      <style>{globalStyles}</style>
      <Toaster position="top-center" toastOptions={{
        style: { background: '#1d1d27', color: '#dde3ef', border: '1px solid #2a2a3a', fontSize: 14 }
      }} />
      <Routes>
        {/* QR kod bu URL-i açır: /menu/:tableId */}
        <Route path="/menu/:tableId" element={<MenuPage />} />
        {/* Sifariş statusu */}
        <Route path="/order/:orderId" element={<OrderStatusPage />} />
        {/* Giriş nöqtəsi */}
        <Route path="/" element={<div style={{display:'flex',alignItems:'center',justifyContent:'center',minHeight:'100vh',flexDirection:'column',gap:16,color:'#dde3ef',background:'#0d0d12',fontFamily:'system-ui,sans-serif'}}>
          <div style={{fontSize:52,color:'#00c896'}}>⬡</div>
          <div style={{fontSize:24,fontWeight:800,letterSpacing:'0.06em'}}>BAKU GATE</div>
          <div style={{color:'#7a8899',fontSize:14}}>QR kodu skan edin restorana daxil olmaq üçün</div>
        </div>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
